import React, {Component} from 'react';
import { Row, Col, Form, message, Input, Checkbox} from 'antd';
import ApiService from '../../actions/apiService';
const { TextArea } = Input;
const FormItem = Form.Item;
class EmailToMembers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: ""
    };
  }
  
  handleSubmit = (e) => {
    e.preventDefault()
  }
  
  render() {
    return (
      <Row gutter={16}>
        <Col gutter={16} sm={24}>
          <Form layout={'vertical'}>
            <FormItem label='Title'>
              <Input />
            </FormItem>
            <FormItem label="Body">
              <TextArea placeholder="body" autosize={{minRows: 5,}}/>
            </FormItem>
            <FormItem>
              <Checkbox>SMS</Checkbox>
              <Checkbox>Email</Checkbox>
            </FormItem>
            <Col sm={24} style={{textAlign: 'right'}}>
              <button type="submit" style={{width: '200px', background: '#3190ff', color: '#fff'}} className="ant-btn ant-btn-submit" onClick={this.handleSubmit}>Save</button>
            </Col>
          </Form>
        </Col>
      </Row>
    )
  }
}
export default EmailToMembers;





// WEBPACK FOOTER //
// ./src/components/Admin/emailToMembers.js